var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashcanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PROFILE---My-Documents-_Desktop_",
    "data-name": "PROFILE---My-Documents-(Desktop)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.525 9.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M.59.556H3.14V.3A.3.3,0,0,1,3.447,0h1.63a.3.3,0,0,1,.307.3V.556h2.55a.574.574,0,1,1,0,1.148H.59A.574.574,0,1,1,.59.556",
    transform: "translate(0 -0.001)",
    fill: "current",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M5.375,6.725v3.12a.281.281,0,0,1-.561,0V6.725a.281.281,0,0,1,.561,0Zm1.683,0v3.12a.281.281,0,0,1-.561,0V6.725a.281.281,0,0,1,.561,0Zm-3.365,0v3.12a.281.281,0,0,1-.562,0V6.725a.281.281,0,0,1,.562,0ZM1.595,4.34h7v6.912a1,1,0,0,1-1.015.979H2.61a1,1,0,0,1-1.015-.979Z",
    transform: "translate(-0.831 -2.264)",
    fill: "current",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanIcon);
export default __webpack_public_path__ + "static/media/trashcan-icon.71b70e0e.svg";
export { ForwardRef as ReactComponent };